<template>
  <div class="vote-banner">
    <div tabindex="0">

      Wystartowała 13. edycja muzycznego <span>Polskiego Topu Wszech Czasów.</span>
       To ranking, który układają tysiące słuchaczy radiowej Trójki. 
       W tym roku każdy może oddać głos na <span>66</span> polskich utworów. 
       Głosowanie trwa od <span>2 marca</span> do <span>27 kwietnia, do godziny 12.00.</span>
    </div>
  </div>
</template>

<script>
import mixin from "../mixin";

export default {
  mixins: [mixin],
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
.vote-banner {
  width: 100%;
  height: 15rem;
  background-image: url(/img/voteBanner.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  margin: 1rem 0;
  border-radius: 5px;
  color: #c5d0ee;
  font-family: "Poppins", sans-serif;
  font-size: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    width: 80%;
    line-height: 2rem;
  }
  span {
    font-weight: 700;
  }
}
</style>
